import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import ProductManagementTable from '../../components/admin/ProductManagementTable';
import Pagination from '../../components/common/Pagination';
import FormInput from '../../components/forms/FormInput';
import { useProducts } from '../../hooks/useProducts';
import { useProductFilters } from '../../hooks/useProductFilters';
import { productService } from '../../services/product.service';
import { useToast } from '../../components/common/Toast';
import { theme } from '../../config/theme';

const AdminProducts = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { filters, updateFilter, getActiveFilters } = useProductFilters();
  const { products, pagination, loading, goToPage, refresh } = useProducts(getActiveFilters());

  const handleProductClick = (product) => {
    // ✅ FIX: Navigate to admin product details using product.id
    navigate(`/admin/products/${product.id}`);
  };

  const handleDelete = async (product) => {
    if (!window.confirm(`Delete "${product.name}"?`)) return;
    
    try {
      await productService.delete(product.id);
      toast.success('Product deleted');
      refresh();
    } catch (error) {
      toast.error('Failed to delete product');
    }
  };

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl }}>
        <h1 style={{ fontSize: theme.typography.fontSize['3xl'], fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.xl }}>
          All Products
        </h1>

        <div style={{ marginBottom: theme.spacing.lg, maxWidth: '400px' }}>
          <FormInput
            placeholder="Search products..."
            value={filters.search || ''}
            onChange={(e) => updateFilter('search', e.target.value)}
          />
        </div>

        {loading ? (
          <div style={{ padding: theme.spacing['3xl'], textAlign: 'center' }}>Loading...</div>
        ) : (
          <>
            <ProductManagementTable
              products={products}
              onProductClick={handleProductClick}
              onDelete={handleDelete}
            />

            <Pagination
              currentPage={pagination.page}
              totalPages={pagination.totalPages}
              hasNextPage={pagination.hasNextPage}
              hasPreviousPage={pagination.hasPreviousPage}
              totalItems={pagination.total}
              itemsPerPage={pagination.limit}
              onPageChange={goToPage}
            />
          </>
        )}
      </div>
    </MainLayout>
  );
};

export default AdminProducts;